import { getDocs } from "firebase/firestore";
import React, { useContext, useEffect, useState } from "react";
import {
  orderCollectionRef,
  readData,
} from "../component/user/GettingData/firebase";

const StoreContextTemplate = {
  storeProducts: [],
  filteredStoreProducts: [],
  handleFilterKeyInput: () => {},
};

const StoreContext = React.createContext(StoreContextTemplate);

export const useStore = () => {
  return useContext(StoreContext);
};

export const StoreProvider = ({ children }) => {
  const [storeProducts, setStoreProducts] = useState([]);
  const [filteredStoreProducts, setFilteredStoreProducts] = useState([]);
  // const []
  const [filterKey, setFilterKey] = useState("");
  const [isAuth, setIsAuth] = useState(false);
  const [choosenProducts, setChoosenProducts] = useState([]);
  const [orders, setOrders] = useState();

  useEffect(() => {
    function fetchStoreProducts() {
      // const URL = 'https://cors-anywhere.herokuapp.com/https://apimocha.com/efy1324/store'
      // const { data: storeProductsData } = await axios.get(URL)
      // setStoreProducts(storeProductsData)
      readData((data) => {
        if (data) {
          setStoreProducts(data);
        } else {
          console.log("something worng!");
        }
      });
    }

    fetchStoreProducts();
  }, []);

  useEffect(() => {
    const id = setTimeout(() => {
      setFilteredStoreProducts(
        storeProducts.filter(
          (product) =>
            product.productName.includes(filterKey) ||
            product.category.includes(filterKey) ||
            product.id == filterKey
        )
      );
    }, 1500);

    return () => clearTimeout(id);
  }, [filterKey, storeProducts]);
  useEffect(()=>{
    const users =[]
   const customers = storeProducts.forEach((product)=>{
    if(product.price == 0 || product.outOfStock){
      console.log(product)
      users.push(product)
    }
    console.log(users.length)
   })

  },[storeProducts])
  useEffect(() => {
    const getOrders = async () => {
      const data = await getDocs(orderCollectionRef);
      setOrders(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getOrders();
  }, []);

  const handleFilterKeyInput = ({ target: { value } }) => setFilterKey(value);

  return (
    <StoreContext.Provider
      value={{
        storeProducts,
        filteredStoreProducts,
        handleFilterKeyInput,
        isAuth,
        setIsAuth,
        choosenProducts,
        setChoosenProducts,
        orders,
        setOrders,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};
